/**
 * Carousel
 */
var component_carousel = function(args) {

  // setup args
  var carousel = args.carousel

  // validate
  if (!carousel) {
    console.log('Invalid carousel');
    return;
  }

  /**
   * Render navigation bullets
   */
  function render_bullets(numOfSlides) {
    let bulletsContainer = carousel.querySelector('.glide__bullets');
    for (var i = 0; i < numOfSlides; i++) {
      let bullet = document.createElement('button');
      bullet.classList.add('glide__bullet');
      bullet.setAttribute('data-glide-dir', `=${i}`);
      bullet.setAttribute('tabindex', '-1');
      bulletsContainer.appendChild(bullet);
    }
  }

  /**
   * Init
   */
  function init_carousel() {
    if (carousel) {
      try {
        let slider = new Glide(carousel, {
          type: 'carousel',
          animationDuration: 500,
          // autoplay: 5000,
          autoplay: false,
          hoverPause: true,
          perView: 1,
        });

        // before slider mount
        slider.on('mount.before', () => {
          let slides = carousel.querySelectorAll('.polar-carousel__slide');
          // filter out the clone slides
          slides = Array.from(slides).filter((slide) => {
            if (!slide.classList.contains('glide__slide--clone')) {
              return true;
            }
          });
          render_bullets(slides.length);
        })

        // mount slider
        slider.mount();

        } catch (e) {
          console.log(e);
       }
    }
  }

  init_carousel();

  // make the call chainable
  return this;

};

